import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogCloseButton,
} from '@wwe-portal/ui/components/dialog';
import { cn } from '@wwe-portal/ui/lib/lib';

interface YoutubeVideoPopupProps {
  show: boolean;
  link: string;
  className?: string;
  onClose?: () => void;
  setShow: (value: boolean) => void;
}

const YoutubeVideoPopup: React.FC<YoutubeVideoPopupProps> = ({
  show,
  onClose,
  link,
  className,
  setShow,
}) => {
  return (
    <Dialog
      onOpenChange={(isOpen) => {
        setShow(!isOpen);
      }}
      open={show}
    >
      <DialogContent
        className={cn('p-[30px] md:h-[520px] md:w-[420px]', className)}
        data-id="login-dialog"
        variant="message"
      >
        <iframe
          width="100%"
          height="100%"
          style={{ minHeight: 400 }}
          src={`${link}?autoplay=1`}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; local-network-access"
          allowFullScreen
          title="randomer"
        />
        <DialogCloseButton onClose={onClose} />
      </DialogContent>
    </Dialog>
  );
};

export default YoutubeVideoPopup;
